import React, { PropsWithChildren } from "react";
import useCellDescriptor from "../dataTable/utils/useCellDescriptor";
import { Column } from "../dataTable/Column";
import {
  createColumnHelper,
  flexRender,
  getCoreRowModel,
  useReactTable,
} from "@tanstack/react-table";

export interface ITableProps {
    data:any[]
  children: React.ReactNode;
}

const columnHelper = createColumnHelper<any>();

export const Table2 = ({data, children }: ITableProps) => {

  const { columns } = useCellDescriptor(children as any);

  const allColumns = columns.map((col) =>
    columnHelper.accessor(col.fieldName, {
      cell: (info) => info.getValue(),
      footer: (info) => info.column.id,
    })
  );


  const table = useReactTable({
    data,
    columns: allColumns,
    getCoreRowModel: getCoreRowModel(),
  })

  return (
    <>
      <table>
        <thead>
          {table.getHeaderGroups().map(headerGroup => (
            <tr key={headerGroup.id}>
              {headerGroup.headers.map(header => (
                <th key={header.id}>
                  {header.isPlaceholder
                    ? null
                    : flexRender(
                        header.column.columnDef.header,
                        header.getContext()
                      )}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody>
          {table.getRowModel().rows.map(row => (
            <tr key={row.id}>
              {row.getVisibleCells().map(cell => (
                <td key={cell.id}>
                  {flexRender(cell.column.columnDef.cell, cell.getContext())}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
        <tfoot>
          {table.getFooterGroups().map(footerGroup => (
            <tr key={footerGroup.id}>
              {footerGroup.headers.map(header => (
                <th key={header.id}>
                  {header.isPlaceholder
                    ? null
                    : flexRender(
                        header.column.columnDef.footer,
                        header.getContext()
                      )}
                </th>
              ))}
            </tr>
          ))}
        </tfoot>
      </table>
    </>
  );
};

Table2.displayName = "@modir/ui-mantine/Table";
Table2.Column = Column;
